export type ReportRef = {
    id: string | null;
    name: string | null;
    // Set when the dashboard's embed config could not be loaded. The id stays null so
    // nothing is sent to the assistant, but the name is kept so the chat can say which
    // report is unavailable instead of silently pointing at the previous one.
    failed?: boolean;
};

type Listener = (report: ReportRef) => void;

let _report: ReportRef = { id: null, name: null };
const listeners: Listener[] = [];

export function getReport(): ReportRef {
    return _report;
}

export function getReportId(): string | null {
    return _report.id;
}

export function setReport(report: ReportRef) {
    _report = { id: report.id || null, name: report.name || null, failed: !!report.failed };
    for (const l of listeners) {
        try { l(_report); } catch { }
    }
}

export function subscribe(listener: Listener): () => void {
    listeners.push(listener);
    return () => {
        const idx = listeners.indexOf(listener);
        if (idx >= 0) listeners.splice(idx, 1);
    };
}
